<!-- src/views/NotFound.vue -->
<template>
  <div class="container" style="padding-top: 24px;">
    <h4>Page not found</h4>
    <p class="grey-text">The page you requested does not exist.</p>

    <router-link class="btn blue-grey darken-3" :to="{ name: 'VenueDashboard' }">
      Go to Dashboard
    </router-link>
  </div>
</template>
